import React from 'react';

type Props = {
  title: string;
  options: {
    label: string;
    value: string;
    selected: boolean;
    hidden?: boolean;
    onClick: () => void;
  }[];
};

export default function SupportedLanguageButtons(props: Props) {
  const { title = 'Function code', options = [] } = props;

  if (options.length === 0) return null;

  return (
    <div className="languages-container" style={{ paddingTop: 'var(--spacing-md)' }}>
      <span className="languages-label">{title}</span>
      <div className="buttons">
        {options.map((option) => {
          if (option?.hidden) return null;
          return (
            <button
              role="button"
              onClick={option.onClick}
              className={option.selected ? 'rounded-border selected' : 'rounded-border no-selected'}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
